/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 6/5/14
 * Time: 11:13 AM
 * Some documentation:  ( Tomer to write more later)
 * Page component is designed top be General page in the system - this way tommorow when PM/UIX/UX decide on different design we change it here
 * or just add another permutation on it.
 *
 * The page component started by wanting to have one css/template for all pages that look like dialog overlay but are not
 * All these pages has got the same design title, description, actions strip, x close button,
 * middle view with all its forms and then a footer area.
 *
 * To use:
 *
 * Create the page in your controller and pass into it your inner view.
 *this.contentGalleryLayout = new ContentGalleryLayout({
                    vent: this.vent,
                    model: this.model
  });

 this.mainView = new Page({
                    isPermanent: true, An option override for marrionete regions if the page is inside a region using show with another view will not close it
                    view:        this.contentGalleryLayout,
                    title:       this.model.getHeaderTitle(),
                    description: this.model.getHeaderDescription(),
                    hasActionStrip: true | false,
                    moduleName: LECampaigns.moduleName, // REQUIRED for Dialog permutation
                    context: LE.context, // REQUIRED for Dialog permutation
                    ignoreDomEvents: true | false // if set to TRUE will ignore the onKeyUp handler from DomEvents utility
  });

 CSS and templates:
 The dialog page template contains header button and inside view container.
 The dialog page CSS calculates the size remaining for the inner view if it with/without description
 The dialog page CSS calculates the size remaining for the inner view if it with/without action strip
 and also position the footer element.

 So what should the inside view template use:
 .page-action-strip{

 }
 .view-container{

 }
 .page-footer {
       .buttons-container {
       }
 }

 Functionalities
 *
 * The inner view can trigger  showLoader,closeLoader,close events and the page will respond
 * The inner view  should listen to "page:closeButtonClick" event and decide what to do with it.
 *
 * API
 * setTitle
 * setDescription
 * setActionStrip
 * setInsideView
 * showLoader
 * closeLoader
 *
 * Inner view can trigger
 */
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var PageHeaderView = require("ui/page/js/views/PageHeaderView");
    var dialogPageTemplate = require("ui/page/templates/dialogPage.tmpl");
    var standardPageTemplate = require("ui/page/templates/standardPage.tmpl");
    var customPageTemplate = require("ui/page/templates/customPage.tmpl");
    var Loader = require("ui/loader/Loader");
    var DomEvents = require("infra-util/DomEvents");
    var Logger = require("logger");

    var WITH_FOOTER_CLASS = "with-footer";
    var DESCRIPTION_CLASS = "with-description";
    var ACTION_STRIP_CLASS = "with-action-strip";
    var NO_HEADERS_CLASS = "no-headers";
    var ESCAPE_KEY_CODE = 27;

    var PERMUTATION = {
        Dialog: "dialog-page",
        Standard: "standard-page",
        Custom:   "custom-page"
    };

    var CONTENT_WIDTH = {
        XSmall: "content-width-xsmall",
        Small: "content-width-small",
        Medium: "content-width-medium",
        Large: "content-width-large",
        XLarge: "content-width-xlarge",
        XXLarge: "content-width-xxlarge",
        Full: "content-width-full"
    };

    var PAGE_TEMPLATES = {};
    PAGE_TEMPLATES[PERMUTATION.Dialog] = dialogPageTemplate;
    PAGE_TEMPLATES[PERMUTATION.Standard] = standardPageTemplate;
    PAGE_TEMPLATES[PERMUTATION.Custom] = customPageTemplate;

    var REGION_SHOW_FUNCTION_NAMES = {
        SHOW: "show",
        ADD:  "add"
    };

    var Page = Marionette.Layout.extend({
        className: "page",
        ui: {
            header: ".page-header",
            insideViewContainer: ".page-inside-view-container",
            footer: ".page-footer"
        },
        regions: {
            headerViewRegion: ".page-header",
            insideViewRegion: ".page-inside-view-container",
            footerViewRegion: ".page-footer"
        },
        events: {
            "click .page-close-btn" : "_onCloseButtonClick"
        },
        initialize: function(options) {
            this.logger = Logger.getLogger("Page");
            this.logger.debug("Initializing Page", "Page:initialize", {options: options});
            this.pageId = (new Date()).getTime().toString();
            this.permutation = options.permutation || Page.PERMUTATION.Dialog;
            this.contentWidth = options.contentWidth || CONTENT_WIDTH.Full;
            this.template = this._getTemplate();
            this.moduleName = options.moduleName;
            this.context = options.context;
            this.additionalClassName = options.additionalClassName || "";
            this.ignoreDomEvents = _.has(options, "ignoreDomEvents") ? options.ignoreDomEvents : false;
            this.header = options.header;
            this.headerView = (this.header instanceof Marionette.View) ? options.header : new PageHeaderView(this._getHeaderViewOptions());
            this.insideView = options.view;
            this.footerView = (options.footer instanceof Marionette.View) ? options.footer : null;

            this.headerViewRegionFunction =  options.headerViewRegionFunction || REGION_SHOW_FUNCTION_NAMES.SHOW;
            this.insideViewRegionFunction =  options.insideViewRegionFunction || REGION_SHOW_FUNCTION_NAMES.SHOW;
            this.footerViewRegionFunction =  options.footerViewRegionFunction || REGION_SHOW_FUNCTION_NAMES.SHOW;

            this.hasActionStrip = _.has(options, "hasActionStrip") ? options.hasActionStrip : false;
            this.isPermanent = _.isUndefined(options.isPermanent) ? false : options.isPermanent; //make the view permanent in the marrionete region

        },

        _getHeaderViewOptions: function() {
            var title = _.has(this.header, "title") ? this.header.title : "";
            var description = _.has(this.header, "description") ? this.header.description : "";
            var beta = _.has(this.header, "beta") ? this.header.beta : false; // should be TRUE/FALSE
            var feedback = _.has(this.header, "feedback") ? this.header.feedback : null; // should be link to open or null
            return {
                moduleName: this.moduleName,
                context: this.context,
                title: title,
                description: description,
                beta: beta,
                feedback: feedback
            };
        },

        onRender: function() {
            this.logger.debug("Rendering Page", "Page:onRender", {moduleName: this.moduleName,title: this.header?this.header.title:""});
            this.$el.addClass(this.permutation);
            if (!_.isEmpty(this.additionalClassName)) {
                this.$el.addClass(this.additionalClassName);
            }
            this.renderHeaderView();
            this.renderInsideView();
            this.renderFooterView();

            this.updateDescriptionState();
            this.updateActionStripState();
            this.updateHeadersState();
            this.updateContentWidth(true);
            this.updateFooterState();

            if (this.permutation == Page.PERMUTATION.Dialog) {
                if (this.context && this.moduleName) {
                    DomEvents.on("keyup", this.pageId, this.moduleName, this.context, _.bind(this.onKeyup, this));
                }
            }
        },

        renderHeaderView: function() {
            if (this.permutation !== Page.PERMUTATION.Custom) {
                this.logger.debug("renderHeaderView ", "Page:renderHeaderView");
                if (this.headerView) {
                    this.listenTo(this.headerView, "headerTabsChange", this._onHeaderTabsChange);

                    this.headerViewRegion[this.headerViewRegionFunction](this.headerView);
                }
            }
        },

        _onHeaderTabsChange: function(selectedTabId) {
            this.insideView.trigger("page:headerTabsChange", selectedTabId);
        },

        renderInsideView: function(viewOptions) {
            this.logger.debug("renderInsideView ", "Page:renderInsideView");
            if (this.insideView) {
                //listening must come before region show
                this.listenTo(this.insideView, "showLoader", this.showLoader);
                this.listenTo(this.insideView, "closeLoader", this.closeLoader);

                this.insideViewRegion[this.insideViewRegionFunction](this.insideView);

            }
            else {
                this.insideViewRegion.reset();
            }
        },

        renderFooterView: function(viewOptions) {
            if (this.permutation === Page.PERMUTATION.Standard) {
                this.logger.debug("renderFooterView ", "Page:renderFooterView");
                if (this.footerView) {
                    this.footerViewRegion[this.footerViewRegionFunction](this.footerView);

                }
            }
        },

        updateFooterState: function() {
            this.logger.debug("updateFooterState ", "Page:updateFooterState");
            var hasFooter = !_.isNull(this.footerView);
            this.ui.insideViewContainer.toggleClass(WITH_FOOTER_CLASS, hasFooter);
            this.ui.footer.toggleClass(WITH_FOOTER_CLASS, hasFooter);
        },

        updateDescriptionState: function() {
            this.logger.debug("updateDescriptionState ", "Page:updateDescriptionState");
            var hasDescription = this.hasDescription();
            this.ui.header.toggleClass(DESCRIPTION_CLASS, hasDescription);
            this.ui.insideViewContainer.toggleClass(DESCRIPTION_CLASS, hasDescription);
        },

        updateHeadersState: function() {
            this.logger.debug("updateHeadersState ", "Page:updateHeadersState");
            var hasHeaders = this.hasDescription() || this.hasTitle();
            this.ui.header.toggleClass(NO_HEADERS_CLASS, !hasHeaders);
            this.ui.insideViewContainer.toggleClass(NO_HEADERS_CLASS, !hasHeaders);
        },

        hasDescription: function() {
            var pageDescriptionUI = this.ui.header.find(".page-description");
            if (pageDescriptionUI.find(".description-content").length > 0) {
                pageDescriptionUI = pageDescriptionUI.find(".description-content");
            }

            return (pageDescriptionUI.length > 0 && pageDescriptionUI.text().length > 0);
        },

        hasTitle: function() {
            var pageTitleUI = this.ui.header.find(".page-title");
            if (pageTitleUI.find(".title-content").length > 0) {
                pageTitleUI = pageTitleUI.find(".title-content");
            }

            return (pageTitleUI.length > 0 && pageTitleUI.text().length > 0);
        },

        updateActionStripState: function() {
            this.logger.debug("updateActionStripState ", "Page:updateActionStripState");
            this.ui.insideViewContainer.toggleClass(ACTION_STRIP_CLASS, this.hasActionStrip);
        },


        updateContentWidth: function(toggleClass) {
            this.logger.debug("updateContentWidth ", "Page:updateContentWidth");
            if (this.permutation === Page.PERMUTATION.Standard) {
                this.ui.header.toggleClass(this.contentWidth, toggleClass);
                this.ui.insideViewContainer.toggleClass(this.contentWidth, toggleClass);
            }
        },

        setIgnoreDomEvents: function (ignoreDomEvents) {
            this.ignoreDomEvents = ignoreDomEvents;
        },

        setContentWidth: function(contentWidth) {
            this.updateContentWidth(false);
            this.contentWidth = contentWidth;
            this.updateContentWidth(true);
        },

        setActionStrip: function(hasActionStrip) {
            this.hasActionStrip = hasActionStrip;
            this.updateActionStripState();
        },

        setHeaderView: function(headerView) {
            this.logger.debug("setHeaderView ", "Page:setHeaderView");
            if (this.headerView) {
                this.stopListening(this.headerView);
            }

            this.headerView = headerView;
            this.renderHeaderView();
            this.updateDescriptionState();
            this.updateHeadersState();
        },

        setFooterView: function(footerView) {
            this.logger.debug("setFooterView ", "Page:setFooterView");
            this.footerView = footerView;
            this.renderFooterView();
            this.updateFooterState();
        },

        setTitle: function(title) {
            this.logger.debug("setTitle "+ title, "Page:setTitle");
            if (this.headerView && _.isFunction(this.headerView.setTitle)) {
                this.headerView.setTitle(title);
            }
            this.updateHeadersState();
        },

        setDescription: function(description) {
            this.logger.debug("setDescription" + description, "Page:setDescription");
            if (this.headerView && _.isFunction(this.headerView.setDescription)) {
                this.headerView.setDescription(description);
            }
            this.updateDescriptionState();
            this.updateHeadersState();
        },

        setBeta: function(isBeta) {
            this.logger.debug("setBeta" + isBeta, "Page:setBeta");
            if (this.headerView && _.isFunction(this.headerView.setBeta)) {
                this.headerView.setBeta(isBeta);
            }
        },

        setFeedback: function(feedback) {
            this.logger.debug("setFeedback" + feedback, "Page:setFeedback");
            if (this.headerView && _.isFunction(this.headerView.setFeedback)) {
                this.headerView.setFeedback(feedback);
            }
        },
        /**
         * Replace existing inside view with a new one
         * @param insideView
         */
        setInsideView: function(insideView) {
            this.logger.debug("setInsideView", "Page:setInsideView");
            if (this.insideView) {
                this.stopListening(this.insideView);
            }
            this.insideView = insideView;
            this.renderInsideView();
        },

        getInsideView: function() {
            return this.insideView;
        },

        showLoader: function (options) {
            this.logger.debug("showLoader", "Page:showLoader");
            var permutation = _.has(options, "permutation") ? options.permutation : Loader.PERMUTATION.A;
            var el = _.has(options, "el") ? options.el : this.$el; //".interaction-area-item-wrapper.open";
            var zIndex = _.has(options, "zIndex") ? options.zIndex : 999999;
            var text = _.has(options, "text") ? options.text : '';
            var button = _.has(options, "button") ? options.button : '';

            if (!this.loader) {
                this.logger.debug("creating new loader", "Page:showLoader");
                this.loader = new Loader({
                    permutation: permutation,
                    el: el,
                    zIndex: zIndex,
                    text: text,
                    button: button
                });
                this.loader.render();
            }
        },

        closeLoader: function () {
            this.logger.debug("closeLoader", "Page:closeLoader");
            if (this.loader) {
                this.logger.debug("closing existing Loader", "Page:closeLoader");
                this.loader.close();
                this.loader = null;
            }
        },

        onKeyup: function (event) {
            if (!this.ignoreDomEvents) {
                if (event.keyCode == ESCAPE_KEY_CODE) {
                    this._onCloseButtonClick(event);
                }
            }
        },

        _onCloseButtonClick: function(event) {
            if (this.insideView) {
                this.insideView.trigger("page:closeButtonClick", {event: event});
            }
        },

        _getTemplate: function() {
            return PAGE_TEMPLATES[this.permutation];
        },

        onClose: function() {
            DomEvents.off("keyup", this.pageId);
            this.closeLoader();
            this.logger.debug("Closing Page", "Page:close",{moduleName: this.moduleName,title: this.header?this.header.title:""});
        }
    });

    Page.PERMUTATION = PERMUTATION;
    Page.CONTENT_WIDTH = CONTENT_WIDTH;
    Page.REGION_SHOW_FUNCTION_NAMES = REGION_SHOW_FUNCTION_NAMES;

    return Page;
});
